var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "memo-circle-check",
    d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm3.192,6.2-2.213,2.124A2.348,2.348,0,0,1,17.326,21a2.375,2.375,0,0,1-1.663-.674l-1.132-1.109a1,1,0,1,1,1.4-1.428l1.131,1.108a.374.374,0,0,0,.522,0l2.223-2.134A1,1,0,0,1,21.192,18.2ZM10,18a7.98,7.98,0,0,1,2.709-6H5a1,1,0,0,1,0-2h8a1,1,0,0,1,1,1q0,.036,0,.072A7.958,7.958,0,0,1,18,10V5a5.006,5.006,0,0,0-5-5H5A5.006,5.006,0,0,0,0,5V19a5.006,5.006,0,0,0,5,5h7.709A7.98,7.98,0,0,1,10,18ZM5,5h8a1,1,0,0,1,0,2H5A1,1,0,0,1,5,5ZM7,17H5a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2Z",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingReview);
export default __webpack_public_path__ + "static/media/pending-review.9cf021de6d31c5920c539906c363adc4.svg";
export { ForwardRef as ReactComponent };